import { createFileRoute } from "@tanstack/react-router";

import { SPECIFICATIONS_BASE_PATH, legacyRedirectTo } from "@/lib/route-paths";

// Legacy bookmark: the old stack's bare `/specifications` had no view of its
// own — it opened the base specifications list. Lives in a directory (rather
// than as a flat `specifications.tsx`) so the Specifications slice can add
// siblings like `base.tsx` without this file becoming their layout route.
export const Route = createFileRoute("/_authed/_chrome/specifications/")({
  beforeLoad: legacyRedirectTo(SPECIFICATIONS_BASE_PATH),
});
